<template>
	<div>

		<div class="row">
			<div class="col-12 text-center" v-if="surveyIsDone == 0">
				<button class="btn btn-sm rounded-pill btn-yellow ml-4 btn-game-box px-4 py-0" @click.prevent="onClickBtn">
					<span class="va-sub">VAI AL QUESTIONARIO</span>
				</button>
			</div>
			<div class="col-12 text-center" v-if="surveyIsDone == 1">
				<button class="btn btn-sm rounded-pill btn-yellow ml-4 btn-game-box px-4 py-0" disabled>
					<i class="fas fa-check va-sub"></i> <span class="va-sub">COMPILATO</span>
				</button>
			</div>
		</div>

		<transition name="fade">
			<div class="popup_container" v-if="showPopUp">
				<div class="container h-100">
					<div class="d-flex justify-content-center align-items-center h-100">

						<transition name="fade-inner">
							<div class="survey position-relative d-flex flex-column justify-content-center" v-if="showSurvey">
								<div class="close position-absolute" @click.prevent="closePopUp">
									<i class="fas fa-times"></i>
								</div>

								<div id="questions-counter" class="position-absolute text-center" v-if="!showFinalMsg">
									<div class="text-center bold mb-1 w-100">{{(questionNo + 1)}} di {{totQuestionsItems}}</div>
								</div>

								<div class="row" v-if="currentQuestionItem.questionType == 'oneTen' && !showFinalMsg">
									<div class="col-12">
										<from-one-to-ten-component
											:question-item="currentQuestionItem"
											@setAnswerValue="checkAnswerValue"
										></from-one-to-ten-component>
									</div>
								</div>

								<div class="row" v-if="currentQuestionItem.questionType == 'abcd' && !showFinalMsg">
									<div class="col-12">
										<abcd-component
											:question-item="currentQuestionItem"
											@setAnswerValue="checkAnswerValue"
										></abcd-component>
									</div>
								</div>

								<div class="row" v-if="showFinalMsg">
									<div class="col-12 text-center">
										<p class="bold fs-1-3">Grazie per aver condiviso con noi la tua opinione.</p>
									</div>
								</div>

								<div class="row" v-if="!showFinalMsg">
									<div class="col-12 text-center mt-2">
										<button class="btn btn-yellow btn-sm rounded-pill px-4 py-0" :disabled=isNextDisabled @click.prevent="nextQuestion">
											<span class="va-sub">AVANTI</span>
										</button>
									</div>
								</div>

								<div class="row" v-if="showFinalMsg">
									<div class="col-12 text-center mt-2">
										<button class="btn btn-yellow btn-sm rounded-pill px-4 py-0" @click.prevent="closePopUp">
											<span class="va-sub">CHIUDI</span>
										</button>
									</div>
								</div>
							</div>
						</transition>

					</div>
				</div>
			</div>
		</transition>

	</div>
</template>

<script>
import axios from 'axios'
import FromOneToTenComponent from './FromOneToTenComponent.vue'
import AbcdComponent from './AbcdComponent.vue'

export default {
	name: 'SurveyComponent',
	props: ['done'],
	components: {FromOneToTenComponent, AbcdComponent},

	watch: {
		done: function (val) {
			this.surveyIsDone = val
		}
	},

	data() {
		return {
			ajaxObj: window.ajax_object,
			showPopUp: false,
			showSurvey: true,
			questionNo: 0,
			totQuestionsItems: 0,
			currentQuestionItem: {},
			showFinalMsg: false,
			surveyIsDone: 0,
			actionType: 'survey',
			ended: 0,
			survey: [
				{
					questionText: '<strong>Quale laboratorio hai apprezzato di più?</strong>',
					questionType: 'abcd',
					questionNo: 1,
					questionList: {
						'A': 'Più insalata per tutti',
						'B': 'Plastica: conoscerla per usarla al meglio',
						'C': 'Cooperare è meglio che litigare',
						'D': 'Orto in classe',
						'E': 'Lettura etichette',
						'F': 'Alimentazione varia',
						'G': 'Frutta e verdura a colori',
						'H': 'Piccole azioni per grandi obiettivi',
						'I': 'Scegliamo bene!'
					},
					answerValue: ''
				},
				{
					questionText: '<strong>Quali materiali e/o spunti hai trovato più utili?</strong>',
					questionType: 'abcd',
					questionNo: 2,
					questionList: {
						'A': 'Schede attività',
						'B': 'Video',
						'C': 'Guida docenti',
						'D': 'Attività scuola-famiglia'
					},
					answerValue: ''
				},
				{
					questionText: '<strong>In una scala da 1 a 10 (considerando 1 come molto negativo e 10 come molto positivo), quanto consideri interessante portare a scuola il tema della sana e corretta alimentazione e della sostenibilità produttiva?</strong>',
					questionType: 'oneTen',
					questionNo: 3,
					answerValue: ''
				},
				{
					questionText: '<strong>Nella prossima edizione, quale nuovo laboratorio vorresti trovare?</strong>',
					questionType: 'abcd',
					questionNo: 4,
					questionList: {
						'A': 'La storia dell’insalata: dalla nascita alla nostra tavola',
						'B': 'Le strategie usate dalle aziende per produrre in modo sostenibile',
						'C': 'Azioni per combattere insieme la crisi climatica',
						'D': 'A tu per tu con i nutrizionisti'
					},
					answerValue: ''
				},
				{
					questionText: '<strong>In una scala da 1 a 10 (considerando 1 come molto negativo e 10 come molto positivo), quanto sono stati utili e coerenti col piano formativo previsto dalla tua scuola i contenuti del progetto?</strong>',
					questionType: 'oneTen',
					questionNo: 5,
					answerValue: ''
				},
				{
					questionText: '<strong>In una scala da 1 a 10 (considerando 1 come molto negativo e 10 come molto positivo), quanto pensi siano stati coinvolti i tuoi alunni?</strong>',
					questionType: 'oneTen',
					questionNo: 6,
					answerValue: ''
				},
				{
					questionText: '<strong>Conoscevi OrtoRomi prima di iniziare il progetto? Se sì, per quali prodotti in particolare?</strong>',
					questionType: 'abcd',
					questionNo: 7,
					questionList: {
						'A': 'Sì, per le insalate pronte',
						'B': 'Sì, per zuppe e piatti pronti',
						'C': 'Sì, per estratti di frutta e verdura',
						'D': 'Non conoscevo OrtoRomi e i suoi prodotti'
					},
					answerValue: ''
				}
			],
			isNextDisabled: true
		}
	},

	methods: {
		onClickBtn() {
			this.currentQuestionItem = this.survey[this.questionNo]
			this.showPopUp = true
		},
		closePopUp() {
			this.$emit('check-survey')
			this.currentQuestionItem = {}
			this.questionNo = 0
			this.resetItemsValues()
			this.showPopUp = false

			let _this = this
			setTimeout(() => {
				_this.$emit('check-survey')
			}, 2000);
		},
		resetItemsValues() {
			this.survey.forEach(items => items.answerValue = '');
		},
		checkAnswerValue(data) {
			this.isNextDisabled = !data.btnNext ? true : false
			this.survey[this.questionNo].answerValue = data.value
		},

		nextQuestion() {
			this.isNextDisabled = true
			let _this = this

			if ((this.questionNo + 1) < this.totQuestionsItems) {
				setTimeout(() => {
					_this.questionNo = _this.questionNo + 1
					_this.showSurvey = false
				}, 100);

				setTimeout(() => {
					_this.currentQuestionItem = this.survey[this.questionNo]
					_this.showSurvey = true
				}, 500);
			} else {
				this.endSurvey()
				setTimeout(() => {
					_this.showSurvey = false
				}, 100);
				setTimeout(() => {
					this.showFinalMsg = true
					_this.showSurvey = true
				}, 500);
			}
		},

		endSurvey() {
			let url = this.ajaxObj.ajax_url

			let formData = new FormData();
			formData.append('action', 'nl_point_action_register')
			formData.append('_nounce_value', this.ajaxObj._nounce_value)
			formData.append('action_type', this.actionType)
			formData.append('survey_data', JSON.stringify(this.survey))

			axios.post(url, formData)
				.then(() => {
					this.ended = 1
				}, (error) => {
					console.log(error);
				});
		}

	},
	mounted() {
		this.surveyIsDone = this.done
		this.totQuestionsItems = this.survey.length
	}
}
</script>

<style scoped>
.popup_container {
	position: fixed;
	top: 0;
	left: 0;
	height: 100vh;
	width: 100vw;
	background-color: rgba(0, 0, 0, 0.8);
	z-index: 9995;
}
video {
	z-index: 9999;
}
.close {
	top: 20px;
	right: 20px;
	color: #000;
	cursor: pointer;
	font-size: 2rem;
}
.survey {
	min-width: 400px;
	max-width: 650px;
	min-height: 400px;
	height: auto;
	background-color: #ffffff;
	border-radius: 2rem;
	padding: 3rem 1.6rem 2rem;
	margin-left: -15px;
}
#questions-counter {
	position: absolute;
	top:15px;
	left:50%;
	transform: translateX(-50%);
}
</style>

